export enum DashboardMetricsWeekEnum {
    MaxInclVatWeek = "maxInclvatWeek",
    MaxExVatWeek = "maxExVatWeek",
    MaxSumProfitWeek = "maxSumProfitWeek",
    MaxAverageBasketWeek = "maxAverageBasketWeek",
    MaxCountTicketWeek = "maxCountTicketWeek",
}

/** Type of metrics and value (percent/nominal) */
export enum HourlyMetricsDashboardEnum {
    InclVat = "inclvat",
    ExVat = "exvat",
    SumProfit = "sumProfit",
    AverageBasket = "averageBasket",
    AverageBasketExVat = "averageBasketExVat",
    CountTicket = "countTicket",

    InclvatPercentageOfDay = "inclvatPercentageOfDay",
    ExvatPercentageOfDay = "exvatPercentageOfDay",
    ProfitPercentageOfDay = "profitPercentageOfDay",
    TicketPercentageOfDay = "ticketPercentageOfDay",

    ComparisonInclVat = "comparisonInclVat",
    ComparisonExVat = "comparisonExVat",
    ComparisonSumProfit = "comparisonSumProfit",
    ComparisonCountTicket = "comparisonCountTicket",
    ComparisonAverageBasket = "comparisonAverageBasket",
    ComparisonAverageBasketExvat = "comparisonAverageBasketExVat",

    PercentOfSpikeInclvat = "percentOfSpikeInclvat",
    PercentOfSpikeExvat = "percentOfSpikeExvat",
    PercentOfSpikeCountTicket = "percentOfSpikeCountTicket",
}
